import { render } from "./DownloadFileModal.vue?vue&type=template&id=f2ab605a&scoped=true"
import script from "./DownloadFileModal.vue?vue&type=script&lang=js"
export * from "./DownloadFileModal.vue?vue&type=script&lang=js"

import "./DownloadFileModal.vue?vue&type=style&index=0&id=f2ab605a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2ab605a"]])

export default __exports__